import React from "react";
import { ProductInterface } from "../../intrefaces/product/product.interface";
import PDF from '../../assets/images/pdf.svg';
import DOC from '../../assets/images/doc.svg';

interface DocsProps {
    product: ProductInterface;
}



export const Docs: React.FC<DocsProps> = ({ product }) => {
    return (
        <>
            <p className="hidden mb:block text-2xl mb-8 font-bold">Документация</p>
            <div className="md:grid md:grid-cols-4 md:gap-4">
                { product.docs.map((doc, i) => <div key={ i } className="mb-2 items-start px-4 py-5 flex md:h-[120px] border-2 border-[#F7F8FA] rounded-2xl">
                    <img src={ doc.type === 'pdf' ? PDF : DOC } alt={ doc.name } width="24" height="24"/>
                    <div className="ml-3 grid grid-rows-2 h-full">
                        <a className="self-start font-bold" href={ doc.link } download={ doc.name }>{ doc.name }</a>
                        <p className="self-end text-gray">{ doc.size }</p>
                    </div>
                </div>) }
            </div>
        </>
    )
}